import { EditOutline30Icon } from "@vygruppen/spor-icon-react";
import {
  PanelAction,
  PanelActions,
} from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/ActionsOverflowMenu";
import { useVehicleBookingAction } from "features/CenterContent/VehicleDetails/ReserveAlternativeTransportDetails/VehicleBooking";
import AddVehicle from "features/VehicleSidebar/VehicleList/AddVehicles/AddVehicle";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";

type Props = {
  vehicle: ReserveAlternativeTransport;
};

export const ReserveVehiclePanelActions: FC<Props> = ({ vehicle }) => {
  const { t } = useTranslation();
  const [showEditModal, setShowEditModal] = useState(false);
  const bookingAction = useVehicleBookingAction(vehicle);

  const editAction: PanelAction = {
    key: "edit",
    label: t("Rediger"),
    leftIcon: <EditOutline30Icon />,
    onSelect: () => setShowEditModal(true),
    modal: showEditModal ? (
      <AddVehicle
        editVehicle={vehicle}
        isReserveBusTabSelected={
          (vehicle.serviceType ?? "RESERVE") === "RESERVE"
        }
        closeModal={() => setShowEditModal(false)}
      />
    ) : null,
  };

  const actions = [editAction, bookingAction];

  return <PanelActions overflowActions={actions} inlineActions={actions} />;
};
